import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const AddAndSearchItemContainer = styled.div`
    display: flex;
    ${media.mobileDevice`
    display:block;
    `}
    .buttonStyle {
        background: none;
        color: #202124;
        border-radius: 0px;
        font-size: 14px;
        padding: 2px 0 0 0;
        font-family: AvenirNextWorld Regular;
        text-transform: none !important;
        border-bottom: 2px solid #fff !important;
        letter-spacing: normal !important;
        margin-right: 20px;
        min-width: 32%;
    }

    .buttonStyleWithBorder {
        color: #202124;
        border-radius: 0px;
        font-size: 14px;
        border-bottom: 2px solid #1010eb !important;
        box-shadow: 0 0 0 0 rgb(211 212 213 / 0%) !important;
        font-weight: bold;
        font-family: AvenirNextWorld Demi;
        padding: 2px 0 0 0;
        line-height: 1;
        text-transform: none !important;
        letter-spacing: normal !important;
        margin-right: 20px;
        min-width: 32%;
    }

    .inputSearch {
        height: 44px;
        padding-left: 16px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 2px solid #ebeded;
        border-radius: 4px;
        padding-right: 16px;
        font-size: 14px;
        margin-bottom: 12px;
        margin-left: ${({ marginLeftInput }) =>
            marginLeftInput ? marginLeftInput : '10px'};
        ${media.mobileDevice`
        padding-left: 10px;
    `}
    }
    .searchtStyle {
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: 6px !important;
    }
    .cardContainer {
        box-shadow: ${({ boxShadow }) =>
            boxShadow ? boxShadow : '0px 0px 6px #00000029'};

        width: ${({ width }) => (width ? width : '50%')};
        background: #ffffff 0% 0% no-repeat padding-box;
        border-radius: 6px;

        ${media.mobileDevice`
            width:100%;
        `}

       @media (min-width :660px) and (max-width: 768px) and (orientation: landscape){
           width: ${({ isCondensedView }) =>
                isCondensedView ? '85%' : '70%'};
        }   
             @media (min-width :769px) and (max-width: 820px) and (orientation: landscape){
           width: ${({ isCondensedView }) =>
                isCondensedView ? '68%' : '70%'};
        }   
        @media (min-width: 768px) and (max-width: 768px) {
            width: ${({ isCondensedView }) =>
                isCondensedView ? '65%' : '50%'};
        }   
        @media (min-width: 810px) and (max-width: 910px)  {
            width: ${({ isCondensedView }) =>
                isCondensedView && '67%' };
        }
        @media (min-width: 940px) and (max-width: 1023px) {
width: ${({ isCondensedView }) =>
isCondensedView ? '65%' : '50%'};
}
        @media (min-width: 1024px) and (max-width: 1190px) {
            width: ${({ isCondensedView }) =>
                isCondensedView ? '65%' : '50%'};
        }
    }
    .inputStyle {
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: 10px !important;
        background-color: transparent;
        height: 40px;
        ::placeholder {
            color: #808080;
            font-family: 'AvenirNextWorld Regular';
        }
    }
    .cardHeader {
        background: #fff;
        border-width: 0;
        margin-left: ${({ marginLeft }) =>
            marginLeft ? marginLeft : '0.7rem !important'};
        width: max-content;

        ${media.mobileDevice`
        width: auto;
        `}
    }
    .MuiAutocomplete-inputFocused {
        opacity: 1;
        border: 0 !important;
        outline: 0;
        border-width: 0 !important; 
        outline: 0 !important;
        padding: 10px !important;
        
        @media (min-width: 768px) {
        width: 87% !important;
        }
    }
    .textMuted {
        font-size: 6px !important;
        color: red !important;
    }
    .notificationBox {
        display: flex;
        border: none;
        padding: 8px 0 0 10px;
    }
    .notificationText {
        color: #14853d;
        font-size: 14px;
        padding-left: 7px;
        letter-spacing: -0.11px;
        font-family: AvenirNextWorld Regular;
    }
`;
export const AddInputStyle = styled.input.attrs(() => ({
    enterKeyHint: 'go',
}))`
    font-size: 14px !important;
    border-width: 0 !important;
    width: 100% !important;
    outline: 0 !important;
    padding: 10px !important;
`;

export const ButtonDiv = styled.div`
    display: flex;
    justify-content: flex-end;
    width: ${({ width }) => (width ? width : null)};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        width: 73%;
    }
`;

export const AddButton = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #1010eb;
    text-align: center;
    font-size: 13px;
    width: 150px;
    height: 34px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1.5px solid #1010eb;
    border-radius: 17px;
    opacity: 1;
    padding-top: 4px;
    white-space: nowrap;
    ${media.mobileDevice`
    width: 150px;
    height: 34px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border-radius: 17px;
    opacity: 1;
    top: 300px;
    right: 15px;
`}
    @media (min-width: 1280px) and (max-width: 1280px) {
        margin-left: 32px;
    }
    @media (min-width: 820px) and (max-width: 820px) {
        margin-left: -4px;
    }
    @media (min-width: 810px) and (max-width: 810px) {
        margin-left: 10px;
    }
    @media (min-width: 768px) and (max-width: 768px) {
        margin-left: -17px;
    }
    @media (min-width: 1024px) and (max-width: 1024px) {
        margin-left: 17px;
    }
    @media (min-width: 912px) and (max-width: 912px) {
        margin-left: 57px;
    }
`;
